//1.引入axios
import axios from 'axios'


//通过promise 封装
let host = location.host
host = host.startsWith('https')?host:('https://'+host)
export function request(config){
  return new Promise((resolve, reject) => {
    //1.创建axios的实例
    const instance = axios.create({
      baseURL: host,
      timeout:5000
    })
    //2.发送真正的请求
    instance(config)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      })
  })
}




// WEBPACK FOOTER //
// ./src/utils/request.js